import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import consola from 'consola';
import USE_MERCURE from '~/const/mercure';
import logout from '~/helpers/logout-helper';
import * as types from './types';
import { createCart, fetchCart, addCart, updateCart, addCartCustomizable } from '~/services/cart';
import { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart } from '~/services/customer';
import isValidToken from '~/helpers/connection-helper';

const formatCustomerCartQuantity = data => {
  let qty = data.split('|').find(a => a.includes('item_qty'));
  qty = qty ? qty.replace('item_qty:', '') : 0;
  return parseInt(qty, 10) || 0;
};

const getGraphQLErrorsCode = err => {
  if (err && err.length) {
    return err[0].extensions.code || '';
  }

  return '';
};

const initCart =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(function* (context) {
    sessionStorage.removeItem('MDM_CART_ADDRESSES');
    sessionStorage.removeItem('MDM_CART_PHONE');
    const {
      createNewCart
    } = yield createCart(context, localStorage.getItem('MDM_ACCESS_TOKEN'));

    if (!createNewCart) {
      throw new Error('MDM_CART_CANNOT_CREATE_TOKEN');
    }

    localStorage.setItem('MDM_CART_TOKEN', createNewCart);
  });

  return function initCart(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default {
  createCart() {
    var _this = this;

    return _asyncToGenerator(function* () {
      yield initCart(_this);
    })();
  },

  fetchCart(_ref2) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref2;
      let cart = null;
      let quantity = null;

      try {
        if (USE_MERCURE(_this2.getters['i18n/locale'].iso)) {
          if (!localStorage.getItem('MDM_CART_TOKEN')) return;
          const {
            data: {
              minicart
            },
            errors
          } = yield fetchCart(_this2, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'));

          if (errors) {
            const code = getGraphQLErrorsCode(errors);

            if (code === 'MERCURE_ERROR_CART_NOTFOUND') {
              localStorage.removeItem('MDM_CART_TOKEN');
            }

            throw new Error(errors);
          }

          cart = minicart.items;
          quantity = minicart.quantity;
        } else {
          localStorage.removeItem('MDM_CART_TOKEN');
          const data = yield fetchCustomerCart(_this2);
          quantity = data.cart;

          if (data && data.user) {
            localStorage.setItem('MDM_MAIL', data.user.user_email);
          }
        }
      } catch (error) {
        consola.error(error);

        if (_this2.$sentry) {
          _this2.$sentry.captureException(error);
        }
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
      }
    })();
  },

  add(_ref3, payload) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit,
        state
      } = _ref3;
      let cart = null;
      let quantity = null;

      try {
        const item = state.items ? state.items.find(p => p.productReference === payload.reference) : {};
        const maxQuantityReached = item && item.quantity >= 30;

        if (USE_MERCURE(_this3.getters['i18n/locale'].iso)) {
          if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
            logout();
          }

          if (!localStorage.getItem('MDM_CART_TOKEN')) {
            yield initCart(_this3);
          }

          if (!maxQuantityReached) {
            const {
              data: {
                addProductsToCart
              },
              errors
            } = yield addCart(_this3, _objectSpread({
              cart: localStorage.getItem('MDM_CART_TOKEN'),
              token: localStorage.getItem('MDM_ACCESS_TOKEN')
            }, payload));

            if (errors) {
              throw new Error(errors[0].message);
            }

            cart = addProductsToCart.items;
            quantity = addProductsToCart.quantity;
          } else {
            const totalQuantity = state.items.reduce((acc, pdt) => acc + pdt.quantity, 0);
            cart = state.items;
            quantity = totalQuantity;
          }
        } else {
          const data = yield addCustomerCart(_this3, payload);
          const currentTotal = state.total;
          cart = [{
            reference: payload.reference,
            productReference: payload.reference,
            quantity: formatCustomerCartQuantity(data)
          }];
          quantity = currentTotal + 1;
        }
      } catch (error) {
        commit(types.SET_CART_SUCCESS, false);
        consola.error(error);

        if (_this3.$sentry) {
          _this3.$sentry.captureException(error);
        }
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
        commit(types.SET_CART_SUCCESS, true);
      }
    })();
  },

  update(_ref4, payload) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref4;
      let cart = null;
      let quantity = null;
      let reference = null;

      const items = _this4.state.cart.items.filter(e => e.productReference === payload.reference);

      if (items.length > 1) {
        reference = items.find(e => e.offer === payload.offer).reference;
      } else {
        reference = items[0].reference;
      }

      try {
        if (USE_MERCURE(_this4.getters['i18n/locale'].iso)) {
          const {
            updateCartItems
          } = yield updateCart(_this4, {
            cart: localStorage.getItem('MDM_CART_TOKEN'),
            token: localStorage.getItem('MDM_ACCESS_TOKEN'),
            quantity: payload.quantity,
            reference
          });
          cart = updateCartItems.items;
          quantity = updateCartItems.quantity;
        } else {
          const data = yield updateCustomerCart(_this4, payload);
          cart = [{
            reference: payload.reference,
            productReference: payload.reference,
            quantity: data.cartItem
          }];
          const response = yield fetchCustomerCart(_this4);
          quantity = response.cart;
        }
      } catch (error) {
        commit(types.SET_CART_SUCCESS, false);
        consola.error(error);

        if (_this4.$sentry) {
          _this4.$sentry.captureException(error);
        }
      } finally {
        commit(types.SET_CART, cart);
        commit(types.SET_CART_QTY, quantity);
        commit(types.SET_CART_SUCCESS, true);
      }
    })();
  },

  addCartCustomizable(_ref5, payload) {
    var _this5 = this;

    return _asyncToGenerator(function* () {
      let {
        state,
        commit
      } = _ref5;
      const currentTotal = state.total;

      try {
        if (USE_MERCURE(_this5.getters['i18n/locale'].iso)) {
          if (localStorage.getItem('MDM_ACCESS_TOKEN') && !isValidToken()) {
            logout();
          }

          if (!localStorage.getItem('MDM_CART_TOKEN')) {
            yield initCart(_this5);
          }

          const {
            addCustomizableProductToCart
          } = yield addCartCustomizable(_this5, localStorage.getItem('MDM_CART_TOKEN'), localStorage.getItem('MDM_ACCESS_TOKEN'), payload);
          commit(types.SET_CART_QTY, currentTotal + 1);
          commit(types.SET_CART, addCustomizableProductToCart.items);
          commit(types.SET_CART_SUCCESS, true);
        } else {
          const data = yield addCustomerCartCustomizable(_this5, payload);

          if (data.success) {
            commit(types.SET_CART_QTY, currentTotal + 1);
            commit(types.SET_CART_SUCCESS, true);
          } else {
            commit(types.SET_CART_SUCCESS, false);
          }
        }
      } catch (error) {
        commit(types.SET_CART_SUCCESS, false);
        consola.error(error);

        if (_this5.$sentry) {
          _this5.$sentry.captureException(error);
        }
      }
    })();
  }

};